<template>
  <div class="index" :class="{active:activeindex ==1}">
    <div class="bg">
      <img class="logo" src="../../static/images/logo.png" alt="" />
      <div class="title">
        <p>全国农产品溯源技术开发中心</p>
      </div>
    </div>
    <div class="box">
      <p class="sutitle">溯源防伪查询平台</p>
      <p class="sueng">TRACTING ANTI-COUNTERFEITING QUERY PLATFROM</p>
      <p class="numberhao">请输入溯源下方数字编码</p>
      <input @click="active()" class="inputbj" style="padding-left:10px;" type="text" placeholder="" v-model="keywords" />
      <div class="kuang" @click="goSearch">
        <div class="bgmask"></div>
        <p>查询</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      keywords: '',
      activeindex: 0
    };
  },
  methods: {
    active() {
      this.activeindex=1
    },
    goSearch() {
      if (!this.keywords) {
        Toast('请填写溯源数字编码');
        return false;
      } else if (this.keywords.length != 16) {
        Toast('编码位数不对,请检查');
        return false;
      }
      this.$router.push('/searchResults?sign_number=' + this.keywords);
    },
  }
};
</script>

<style lang="scss" scoped>
.active{
  background-image: url('../../static/images/search/searchbj.png');
  height: 17rem !important; 
  background-repeat: no-repeat;
  box-sizing: border-box;
  background-size: 100% 100%;
}
.index {
  background-image: url('../../static/images/search/searchbj.png');
  width: 100%;
  height: 17rem;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    padding-top: 1rem;
    .logo {
      display: block;
      width: 3rem;
      height: 2.4rem;
      margin: 0 auto;
    }
    .title {
      color: #0efcff;
      font-size: 0.48rem;
      font-weight: bold;
      text-align: center;
      margin-top: 0.58rem;
      line-height: 0.8rem;
      letter-spacing: 1.5px;
    }
  }
  .box {
    margin: 0.3rem auto;
    width: 5.5rem;
    padding: 0.2rem;
    box-sizing: border-box;
    background-image: url('../../static/images/searchresult/frame.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .sutitle{
      font-size: 30px;
      font-weight: bold;
      background-image: -webkit-linear-gradient(bottom,#44dec5,#4ebcfa);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .sueng{
      font-size: 12px;
      padding-top: 0.1rem;
      color: #b2ecff;
    }
    .numberhao{
      font-size: 15px;
      padding-top: 0.8rem;
    }
    .inputbj{
      color: #ffffff;
      background-image: url('../../static/images/search/searchbtn_select.png');
      background-size: 100%;
      background-repeat: no-repeat;
      display: block;
      position: relative;
      width: 5rem;
      height: 0.8rem;
      line-height: 0.8rem;
      margin: 0.3rem auto 0.6rem;
      border-radius: 5px;
      overflow: hidden;
    }
    p{
      text-align: center;
      color:#0efcff;
    }
    .kuang{
        background-image: url('../../static/images/search/searchbtn.png');
        background-size: 100%;
        background-repeat: no-repeat;
      .bgmask{
      }
      p{
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/search.vue